export const GET = 'GET';
export const NETWORK_ERROR_MESSAGE = 'NETWORK_ERROR';
export const POST = 'POST';
export const USER_AGENT = 'User-Agent';
